export default __webpack_public_path__ + "static/media/noexpl_14_DE.7d51641c.png";